import styled from 'styled-components';
import { fonts } from 'coreComponents/design-system/variables/fonts/fonts';
import { colors } from 'coreComponents/design-system/variables/colors/colors';
export const Wrapper = styled.div `
  background-color: ${colors.white};
`;
export const SectionHeader = styled.div `
  border: 1px solid ${colors.borderGray};
  padding: 16px 16px 8px 16px;

  display: flex;
  justify-content: space-between;

  ${({ isOpen }) => {
    if (isOpen) {
        return `background-color: ${colors.gray};`;
    }
}}
`;
export const HeaderText = styled.div `
  color: ${colors.navyBlue};
  font-family: ${fonts.AvenirNext.regular}, AvenirNext,Arial,sans-serif;
  font-size: 18px;
  font-weight: 600;
`;
export const SectionBody = styled.div `
  border: 1px solid ${colors.borderGray};
  padding: 21px 16px 21px 16px;
`;
